export function trimStart(str: string) {
  var trimmed = str.replace(/^\s+/g, '');
  return trimmed;
}
